import { render, staticRenderFns } from "./printLabels.vue?vue&type=template&id=066c1b5c&scoped=true&"
import script from "./printLabels.vue?vue&type=script&lang=js&"
export * from "./printLabels.vue?vue&type=script&lang=js&"
import style0 from "./printLabels.vue?vue&type=style&index=0&id=066c1b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c1b5c",
  null
  
)

export default component.exports